export default __webpack_public_path__ + "img/caikuma_jumping.860e0ec4.webp";